import React, { useState, useEffect } from "react";
import TitlePage from "../../Shared/TitlePage";
import { dataService } from "../../../Services/data/data.service";
import { Box, } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import { dataListTypes, crudTypes } from '../../../Config/constants';
import { Plus, Search } from 'lucide-react';

import { useNavigate } from 'react-router-dom';
// Components
import CreateAccountCategoryDialog from "./Components/CreateAccountCategoryDialog";
import CreateAccountDialog from "./Components/CreateAccountDialog";
import AccountList from "./Components/AccountList";

function AccountOverviewPage(props) {
    const [firstLoad, setFirstLoad] = useState(0);
    const classes = useStyles();
    const [filters, setFilters] = useState([]);
    const [filterOn, setFilterOn] = useState(false);

    const [selectedFilter, setSelectedFilter] = useState(1);

    // General
    const [allAccounts, setAllAccounts] = useState([]);
    const [allAccountCategories, setAllAccountCategories] = useState([]);
    const [accountCategoryList, setAccountCategoryList] = useState([]);
    const [accountCategoriesCompanies, setAccountCategoriesCompanies] = useState([]);

    // CRUD
    const [createAccountCategoryDialogOpen, setCreateAccountCategoryDialogOpen] = useState(false);
    const [createAccountDialogOpen, setCreateAccountDialogOpen] = useState(false);
    const [createAccountCompanyId, setCreateAccountCompanyId] = useState(null); // When opening the account via a specific company header, the company should already be set to save clicks.

    const [accountCategoryToEdit, setAccountCategoryToEdit] = useState(null);
    const [accountToEdit, setAccountToEdit] = useState(null);

    useEffect(() => {
        dataService.getAllUserCompanyAccounts(props.Login.userid, 0, 0).then(result => {
            setAllAccounts(result);
        });
        dataService.getAllUserCompanyAccountCategories(props.Login.userid, 0, 0).then(result => {
            setAccountCategoriesCompanies(result);
            setAllAccountCategories(result);
        });
    }, [props.Login.userid])

    if (firstLoad === 0) {
        setFirstLoad(1);
    }

    const filter = [
        { number: 1, column: "name", sortOrder: "ASC" },
        { number: 2, column: "name", sortOrder: "DESC" },
    ]

    const dynamicSorting = (property) => {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        let asc = false;
        /* SC: Filter now works both ways (ASC, DESC) */
        if (filter.find(x => x.number === selectedFilter).column === property) {
            if (filter.find(x => x.number === selectedFilter).sortOrder === 'ASC') {
                asc = false;
                setSelectedFilter(filter.find(x => x.column === property && x.sortOrder === 'DESC').number);
            } else {
                asc = true;
                setSelectedFilter(filter.find(x => x.column === property && x.sortOrder === 'ASC').number);
            }
        } else {
            asc = true;
            setSelectedFilter(filter.find(x => x.column === property && x.sortOrder === 'DESC').number);
        }
        if (asc === true) {
            return function (a, b) {
                //ASC A-Z
                var result = (a[property].toLowerCase() > b[property].toLowerCase() ? 1 : -1);
                return result * sortOrder;
            }
        } else {
            return function (a, b) {
                //DESC Z-A
                var result = (a[property].toLowerCase() < b[property].toLowerCase() ? 1 : -1);
                return result * sortOrder;
            }
        }
    }

    const handleSorting = (sortType) => {
        let tempMeasurementRows = [...accountCategoryList]
        setAccountCategoryList(tempMeasurementRows.sort(dynamicSorting(sortType)));
    }

    const toggleFilter = () => {
        if (filterOn) {
            setFilters([]);
        }
        setFilterOn(!filterOn);
    }

    const updateFilters = (type, event) => {
        let tempFilters = [...filters];
        if (tempFilters.some(x => x.type === type)) {
            let index = tempFilters.indexOf(tempFilters.find(x => x.type === type));
            tempFilters.splice(index, 1);
            tempFilters.unshift({ type: type, filterValue: event.target.value });
        }
        else {
            tempFilters.unshift({ type: type, filterValue: event.target.value });
        }
        setFilters(tempFilters);
        filterList(tempFilters);
    }

    const filterList = (thisFilters) => {
        let varFilteredlist = [...allAccountCategories];
        var i;
        for (i = 0; i < thisFilters.length; i++) {
            let filter = thisFilters[i]
            switch (filter.type) {
                case dataListTypes.NAME:
                    varFilteredlist = varFilteredlist.filter(x => x.name.toLowerCase().includes(filter.filterValue.toLowerCase()));
                    break;
                default:
                    varFilteredlist = varFilteredlist.filter(x => x.name.toLowerCase().includes(filter.filterValue.toLowerCase()));
                    break;
            }
        }
        setAccountCategoryList(varFilteredlist)
    }

    const getFilterValue = (type) => {

        let filter = filters.find(x => x.type === type)

        if (filter) {
            return filter.filterValue
        }
        else {
            return ""
        }
    }

    const openCreateAccountCategoryDialog = () => {
        setCreateAccountCategoryDialogOpen(true);
    }

    const closeCreateAccountCategoryDialog = () => {
        setCreateAccountCategoryDialogOpen(false);
        setAccountCategoryToEdit(null);
    }

    const openCreateAccountDialog = (companyId) => {
        setCreateAccountCompanyId(companyId);
        setCreateAccountDialogOpen(true);
    }

    const closeCreateAccountDialog = () => {
        setCreateAccountDialogOpen(false);
        setCreateAccountCompanyId(null);
        setAccountToEdit(null);
    }

    const handleAccountCategoryCrudSuccess = (accountCategory, crudType) => {
        const companyId = accountCategory.companyId;

        // Locate the company with the matching id
        const targetCompany = allAccounts.find(
            (company) => company.id === companyId
        );

        if (!targetCompany) {
            console.error(`Company with ID ${companyId} not found.`);
            return;
        }

        // Initialize the accountCategories array if not present
        if (!targetCompany.accountCategories) {
            targetCompany.accountCategories = [];
        }

        let tempAllAccountCategories = [...allAccountCategories];
        let companyAccountCategories = tempAllAccountCategories.find(x => x.id === companyId)?.accountCategories || [];

        // Switch statement to handle different CRUD types
        switch (crudType) {
            case crudTypes.CREATE:
                accountCategory.accounts = [];
                targetCompany.accountCategories.push(accountCategory);
                companyAccountCategories.push(accountCategory);
                break;

            case crudTypes.UPDATE:
                const indexToUpdate = targetCompany.accountCategories.findIndex((ft) => ft.id === accountCategory.id);
                if (indexToUpdate !== -1) {
                    targetCompany.accountCategories[indexToUpdate] = accountCategory;
                    const companyIndex = companyAccountCategories.findIndex(ft => ft.id === accountCategory.id);
                    if (companyIndex !== -1) {
                        companyAccountCategories[companyIndex] = accountCategory;
                    }
                } else {
                    console.error(`Account category with ID ${accountCategory.id} not found for update.`);
                }
                break;

            case crudTypes.DELETE:
                targetCompany.accountCategories = targetCompany.accountCategories.filter((ft) => ft.id !== accountCategory.id);
                companyAccountCategories = companyAccountCategories.filter(ft => ft.id !== accountCategory.id);
                break;

            default:
                console.error(`Unsupported CRUD operation: ${crudType}`);
                return;
        }

        // Sort alphabetically by name
        targetCompany.accountCategories.sort((a, b) => a.name.localeCompare(b.name));
        companyAccountCategories.sort((a, b) => a.name.localeCompare(b.name));

        setAllAccountCategories(tempAllAccountCategories);
    };


    const handleAccountCrudSuccess = (accounts, crudType) => {
        const accountCategoryId = accounts.accountCategoryId;
        const companyId = accounts.companyId;

        let tempAllAccountCategories = [...allAccountCategories];
        const targetCompany = allAccounts.find(
            (company) => company.id === companyId
        );

        // Is the category new?
        if (accounts.isNewAccountCategory) {
            if (!targetCompany) {
                console.error(`Company with ID ${companyId} not found.`);
                return;
            }

            if (!targetCompany.accountCategories) {
                targetCompany.accountCategories = [];
            }

            let newAccountCategory = {
                id: accountCategoryId,
                name: accounts.accountCategoryName,
                isRevenue: accounts.accountCategoryIsRevenue,
                isActive: true,
                companyId: companyId,
                accounts: []
            };

            tempAllAccountCategories.find(x => x.id === companyId).accountCategories.push(newAccountCategory);
            targetCompany.accountCategories.push(newAccountCategory);
        }

        if (!targetCompany) {
            console.error(`Company with ID ${companyId} not found.`);
            return;
        }

        const accountCategory = targetCompany.accountCategories.find(
            (accountCategory) => accountCategory.id === accountCategoryId
        );

        if (!accountCategory) {
            console.error(`Account category with ID ${accountCategoryId} not found.`);
            return;
        }

        if (!accountCategory.accounts) {
            accountCategory.accounts = [];
        }

        // Switch statement to handle different CRUD types
        switch (crudType) {
            case crudTypes.CREATE:
                accountCategory.accounts.push(accounts.accounts[0]);
                break;

            case crudTypes.UPDATE:
                const originalAccountCategory = allAccounts
                    .map((company) => company.accountCategories)
                    .flat()
                    .find((ac) => ac.accounts && ac.accounts.some((a) => a.id === accounts.accounts[0].id));

                if (originalAccountCategory) {
                    originalAccountCategory.accounts = originalAccountCategory.accounts.filter(
                        (a) => a.id !== accounts.accounts[0].id
                    );
                }

                if (!accountCategory.accounts) {
                    accountCategory.accounts = [];
                }
                accountCategory.accounts.push(accounts.accounts[0]);
                break;

            case crudTypes.DELETE:
                accountCategory.accounts = accountCategory.accounts.filter(
                    (a) => a.id !== accounts.accounts[0].id
                );
                break;

            default:
                console.error(`Unsupported CRUD operation: ${crudType}`);
                return;
        }

        // Sort accounts alphabetically by name
        accountCategory.accounts.sort((a, b) => a.name.localeCompare(b.name));
        targetCompany.accountCategories.sort((a, b) => a.name.localeCompare(b.name));
        tempAllAccountCategories.find(x => x.id === companyId).accountCategories.sort((a, b) => a.name.localeCompare(b.name));

        setAllAccountCategories(tempAllAccountCategories);
    };

    return (
        <React.Fragment>
            <TitlePage Text="Accounts" backbutton={true} {...props} />
            <Box sx={{
                maxWidth: '90%', display: 'flex', justifyContent: 'center', flexDirection: 'column', marginRight: "auto",
                marginLeft: "auto", marginTop: "120px"

            }} >
                <div className={classes.header}>
                    <h1>Accounts</h1>
                    <div className={classes.tableManagementContainer}>
                        <button className={classes.tableManagementContainer__primaryIconButton} onClick={() => openCreateAccountCategoryDialog()}>
                            <Plus className={classes.iconButton__icon} />
                            Create account category
                        </button>
                        <button className={classes.tableManagementContainer__primaryIconButton} onClick={() => openCreateAccountDialog()}>
                            <Plus className={classes.iconButton__icon} />
                            Create account
                        </button>
                    </div>
                </div>
                {/* <div className={classes.tableManagementContainer}>
                    <div className={classes.tableManagementContainer__start}>
                        <div className={classes.searchContainer}>
                            <input placeholder="Search for types" className={classes.search__input} type="text" value={getFilterValue(dataListTypes.NAME)} onChange={(e) => updateFilters(dataListTypes.NAME, e)} />
                            <Search size={16} className={classes.inputIcon} />
                        </div>
                    </div>
                    <div className={classes.tableManagementContainer__end}>
                        <button className={classes.tableManagementContainer__primaryIconButton} onClick={() => openCreateAccountCategoryDialog()}>
                            <Plus className={classes.iconButton__icon} />
                            Create account category
                        </button>
                        <button className={classes.tableManagementContainer__primaryIconButton} onClick={() => openCreateAccountDialog()}>
                            <Plus className={classes.iconButton__icon} />
                            Create account
                        </button>
                    </div>
                </div> */}
                <div className={classes.tablesContainer}>
                    {allAccounts.length > 0 &&
                        allAccounts.map(company => (
                            <AccountList
                                key={company.id}  // Add a unique key for each mapped element
                                toggleFilter={toggleFilter}
                                filters={filters}
                                handleSorting={handleSorting}
                                filterOn={filterOn}
                                filterList={filterList}
                                updateFilters={updateFilters}
                                companyName={company.name}
                                companyId={company.id}
                                rows={company.accountCategories}
                                setAccountToEdit={setAccountToEdit}
                                setAccountCategoryToEdit={setAccountCategoryToEdit}
                                openCreateAccountDialog={openCreateAccountDialog}
                                userId={props.Login.userid}
                                onAccountCategoryDeleteSuccess={handleAccountCategoryCrudSuccess}
                                onAccountDeleteSuccess={handleAccountCrudSuccess}
                            />
                        ))
                    }
                </div>
            </Box>
            <CreateAccountCategoryDialog dialogOpen={createAccountCategoryDialogOpen || accountCategoryToEdit} closeDialog={closeCreateAccountCategoryDialog} accountCategoryToEdit={accountCategoryToEdit} companies={accountCategoriesCompanies} userId={props.Login.userid} onSuccess={handleAccountCategoryCrudSuccess} />
            <CreateAccountDialog dialogOpen={createAccountDialogOpen || accountToEdit} closeDialog={closeCreateAccountDialog} accountToEdit={accountToEdit} companies={accountCategoriesCompanies} createAccountCompanyId={createAccountCompanyId} accountCategories={allAccountCategories} userId={props.Login.userid} onSuccess={handleAccountCrudSuccess} />

        </React.Fragment>
    )
}

export default AccountOverviewPage;

const useStyles = makeStyles({
    tablesContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "32px",
    },

    header: {
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "8px",
        marginBottom: "16px",
    },

    tableManagementContainer: {
        width: "fit-content",
        height: "fit-content",

        display: "flex",
        alignItems: "center",
        gap: "8px",
        flexWrap: "wrap-reverse",
    },

    tableManagementContainer__start: {
        width: "fit-content",

        display: "flex",
        alignItens: "center",
        gap: "8px",
    },

    searchContainer: {
        width: "240px",
        position: 'relative',
    },

    search__input: {
        width: '100%',
        height: '32px',
        boxSizing: 'border-box',

        display: 'flex',
        alignItems: 'center',

        padding: '0px 8px',
        paddingRight: '32px',

        borderRadius: "4px",
        border: "1px solid #DCDCDC",

        fontSize: '14px',
        fontFamily: 'Lato, sans-serif',
        fontWeight: 'normal',
        color: "#0C0E29",

        backgroundColor: "#FFFFFF",

        "&:focus": {
            outline: "none",
            border: "1px solid #C3996B",
        },
    },

    inputIcon: {
        color: "#0C0E29",
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: '8px',
    },

    tableManagementContainer__end: {
        width: "fit-content",

        display: "flex",
        alignItens: "center",
        gap: "8px",
    },

    tableManagementContainer__primaryIconButton: {
        height: "32px",
        padding: "0 12px",
        paddingLeft: "6px",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "white",
        backgroundColor: "#C3996B",

        display: "flex",
        gap: "4px",
        alignItems: "center",

        transition: "all 0.2s ease-in-out",

        "&:hover": {
            backgroundColor: "#a77d4f",
            color: "white",
            cursor: "pointer",
        }
    },

    iconButton__icon: {
        height: "20px",
        width: "20px",

        display: "block",
    },
});